import React, {useState} from "react";
import {PlacedOrderOverview} from "@/data/entities/order";
import {twJoin} from "tailwind-merge";
import {Button, defaultBorderColor, Icon} from "peggirkit";
import {PencilIcon, TrashIcon} from "@heroicons/react/16/solid";
import PrintActions from "@widgets/pos/orders/details/order/actions/PrintActions";
import {FormattedMessage} from "react-intl";
import {posEditOrder} from "@/routing/Router";
import CancelOrderModal from "./cancel/CancelOrderModal";

type Props = {
    order: PlacedOrderOverview,
};

const Actions = ({order}: Props) => {
    const [showCancel, setShowCancel] = useState(false);

    return (
        <div
            className={twJoin(
                "shrink-0 px-6 py-4 bg-white dark:bg-slate-900 border-t",
                "flex flex-row items-end justify-between gap-6",
                defaultBorderColor,
            )}
        >
            <div className={"flex flex-row items-end justify-start gap-3"}>
                <PrintActions order={order}/>

                <Button
                    color={"secondary"}
                    variant={"outline"}
                    iconBefore={<Icon icon={PencilIcon}/>}
                    disabled={order.cancelledOn !== null}
                    buttonAction={{
                        as: "reactRouterLink",
                        actionProps: {
                            to: posEditOrder(order.cartPublicId).absolutePath(),
                        },
                    }}
                >
                    <FormattedMessage id={"edit"}/>
                </Button>
            </div>

            <Button
                color={"danger"}
                variant={"outline"}
                iconBefore={<Icon icon={TrashIcon}/>}
                disabled={order.cancelledOn !== null}
                buttonAction={{
                    as: "button",
                    actionProps: {
                        onClick: () => setShowCancel(true),
                    },
                }}
            >
                <FormattedMessage id={"cancelOrder"}/>
            </Button>

            <CancelOrderModal
                show={showCancel}
                setShow={setShowCancel}
                order={order}
            />
        </div>
    );
};

export default Actions;